import type { AxiosError } from 'axios';
import { Platform } from 'react-native';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Subscription } from './types';

type UpdateSubScriptionVariables = {
  id: number;
  contractSignatureImage?: File;
  contractInitialImage?: File;
  contractSignatureBase64?: string;
  contractInitialBase64?: string;
};
export type CreateSubResponse = {
  subscription: Subscription;
};

export const useSubscriptionUpdateSignature = createMutation<
  CreateSubResponse,
  UpdateSubScriptionVariables,
  AxiosError
>({
  mutationFn: async (variables) => {
    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      return client({
        url: `v2/subscriptions/${variables.id}/signature`,
        method: 'PUT',
        data: {
          contract_signature_base64: variables.contractSignatureBase64,
          contract_initial_base64: variables.contractInitialBase64,
        },
      })
        .then((response) => response.data.data)
        .catch((err: any) => {
          throw new Error(err.response.data.errors.join(', '));
        });
    } else {
      const formData = new FormData();

      formData.append(
        'contract_signature_image',
        variables.contractSignatureImage
      );
      formData.append('contract_initial_image', variables.contractInitialImage);

      return client({
        url: `v2/subscriptions/${variables.id}/signature`,
        method: 'PUT',
        data: formData,
      })
        .then((response) => response.data.data)
        .catch((err: any) => {
          throw new Error(err.response.data.errors.join(', '));
        });
    }
  },
});
